/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'

export const UserPickIsOngoingBetInfo: React.FC = observer(() => {
  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      작성할 경기의<br/>
      <span className="point-color--orange--modal">베팅내역을 선택</span>해주세요.
    </p>
  )
  const body = (
    <div className="guide-box small ">
      작성한 분석글은 수정 및 삭제할 수 없습니다.<br/>
      작성한 분석글이 포함된 경기는 베팅취소할 수 없습니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
